import React , {Component} from 'react';
import {Grid,Cell,ProgressBar} from 'react-mdl';

class Skills extends Component{
  render(){
    return(
      <div>
        <Grid>
          <Cell col={4}>
          <div style={{display:"flex"}}>
          {this.props.skill1}  {/*<ProgressBar style={{margin:"auto",width:"70%"}}progress={this.props.progress} />*/}
          </div>
          </Cell>
          <Cell col={4}>
          <div style={{display:"flex"}}>
          {this.props.skill2}  {/*<ProgressBar style={{margin:"auto",width:"70%"}}progress={this.props.progress} />*/}
          </div>
          </Cell>
          <Cell col={4}>
          <div style={{display:"flex"}}>
          {this.props.skill3}  {/*<ProgressBar style={{margin:"auto",width:"70%"}}progress={this.props.progress} />*/}
          </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/Components/progress.js